import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';

import type { Route } from '@components/AppRouter/types';

import styles from './DesignSubMenuChildren.module.scss';

interface DesignSubMenuItemInterface {
  items: Route[];
  open: boolean;
}

export const DesignSubMenuChildren = ({ open, items }: DesignSubMenuItemInterface): JSX.Element => {
  const {
    location: { pathname },
    push,
  } = useHistory();

  const onClick = useCallback(
    (path, link) => {
      if (link) {
        window.open(path, '_blank');
        return;
      }

      if (path && path !== pathname) {
        push(path);
      }
    },
    [pathname, push],
  );

  return (
    <div className={classnames(styles.children, { [styles.open]: open })}>
      {items.map(
        (child) =>
          !child.hidden && (
            <div
              key={child.title}
              className={classnames(styles.child, {
                [styles.disabled]: !child.path && !child.routes,
              })}
              role="button"
              tabIndex={-1}
              onClick={() => onClick(child.path, child?.link)}
              onKeyDown={() => onClick(child.path, child?.link)}
            >
              {child.title ?? ''}
            </div>
          ),
      )}
    </div>
  );
};
